import utils from 'utils'

class modalBalanceCtrl {
    constructor($scope, $uibModalInstance, items1, items2) {
        $scope.checkLength = function () {
            let str = ''
            for (let i = 0; i < arguments.length; i++) {
                str += arguments[i]
            }
            return utils.lengthForString(str) > 28
        }
        $scope.modaldata = items1
        $scope.dictData = items2
        console.log(items1)
        $scope.isTaxText = '不含税'
        if ($scope.modaldata.isTax == '1') {
            $scope.isTaxText = '含税'
        }
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.okprint = function () {
            $('#J_redinfoprintbox').jqprint({
                importCSS: true, // true表示引进原来的页面的css，默认是true。（如果是true，先会找$("link[media=print]")，若没有会去找$("link")中的css文件）
                printContainer: true, // 表示如果原来选择的对象必须被纳入打印（注意：设置为false可能会打破你的CSS规则）。
                operaSupport: true,
            })
            setTimeout(() => {
                $uibModalInstance.close('cancel')
            }, 5000)
        }
    }
}

modalBalanceCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'items2']
export default modalBalanceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/modalPrintCtrl.js